<template>
<div class="notice-center" :class="pageType">
    <a-row>
        <a-col :span="6" v-if="pageType === 'layer'">
            <a-menu v-model="menuModel" @select="selectMenuHandle" class="ant-side-menu">
                <a-menu-item v-for="item in menus" :key="item.messageType">
                    <a-badge :count="item.count" class="notice-badge">
                        <a-icon :type="item.icon"/>
                        <span>{{ item.messageTypeName }}</span>
                    </a-badge>
                </a-menu-item>
            </a-menu>
        </a-col>
        <a-col :span="pageType === 'layer' ? 18 : 24" class="notice-tabs-container">
            <a-menu v-if="pageType === 'page'" v-model="menuModel" mode="horizontal" @select="selectMenuHandle">
                <a-menu-item v-for="item in menus" :key="item.messageType">
                    <a-badge :count="item.count" class="notice-badge">
                        <a-icon :type="item.icon"/>
                        <span>{{ item.messageTypeName }}</span>
                    </a-badge>
                </a-menu-item>
            </a-menu>
            <a-menu v-model="tabModel" mode="horizontal" @select="selectTabHandle">
                <a-menu-item 
                    v-for="item in tabs" 
                    :key="item.messageNode" 
                    class="item" 
                >
                    <a-badge :count="item.count" class="notice-badge">{{ item.messageNodeName }}</a-badge>
                </a-menu-item>
            </a-menu>
            <template v-if="pageType === 'page'">
                <a-switch class="switch" 
                v-model="isOnRead" checked-children="仅未读" un-checked-children="仅未读" @change="isReadChangeHandle"/>
                <span v-if="pageSetReadShow" class="page-setRead" @click="setAllReadHandle">全部标记为已读</span>
            </template>
            <div class="notice-flex">
                <Loading v-if="loading"></Loading>
                <template v-else>
                    <NoticeList 
                        v-if="noticeList.length" 
                        :data="noticeList" 
                        :pageType="pageType" 
                        :pagination="pagination"
                        @readSuccess="readSuccess"
                        @pageChange="pageChangeHandle"
                    />
                    <div v-else class="no-content">暂无消息</div>
                </template>
            </div>
            <div class="toolbox" v-if="pageType === 'layer'" >
                <span @click="toMore">查看更多>></span>
                <span v-if="noticeList.length" class="setRead" @click="setAllReadHandle">全部标记为已读</span>
            </div>
        </a-col>
    </a-row>
</div>
</template>

<script>
import NoticeList from './notice-list'
import { notifyWebTitle, notify }from '@/libs/utils/notice'
import ReconnectingWebSocket from '@/libs/utils/websocket'
import { formatDate } from '@/libs/utils'
import Loading from '@/components/result/loading'
import { getRoute } from './config'

let socketUrl = (function(){
    let host = location.host
    if (host.includes('d-wyc')) {
        return 'wss://d-wyc-websocket.yun-sk.com/websocket'
    } else if (host.includes('t-wyc')) {
        return 'wss://t-wyc-websocket.yun-sk.com/websocket'
    } else if (host.includes('g-wyc')) {
        return 'wss://g-wyc-websocket.yun-sk.com/websocket'
    }
    return 'wss://wyc-websocket.yun-sk.com/websocket'
})()
const menuIcon = {
    1: 'gift',
    2: 'team',
    3: 'skin'
}
export default {
    components: { NoticeList, Loading },
    props: {
        pageType: String
    },
    data() {
        return {
            menuModel: [],
            menus: [],
            tabModel: [],
            noticeList: [],
            isOnRead: false,
            notifycation: null,
            total: 0,
            pagination: {
                page: 1,
                size: 10,
                total: 10
            },
            loading: false,
            sock: null
        }
    },
    computed: {
        tabs() {
            let model = this.menuModel[0]
            if (model && this.menus.length) {
                let target = this.menus.find(item => item.messageType === model)
                return target && target.nodeList
            }
            return []
        },
        currentUser () {
            return this.$store.state.account.user
        },
        isRead () {
            if (this.pageType === 'layer') {
                return '0'
            } else {
                return this.isOnRead ? '0' : undefined
            }
        },
        pageSetReadShow () {
            return this.noticeList.length && this.noticeList.some(v => v.isRead === 0)
        }
    },
    methods: {
        getNotifiy (fetchParams) {
            this.loading = true
            let params = {
                isRead: this.isRead,
                ...fetchParams,
                ...this.pagination
            }
            this.$axios.get(this.$apis.GET_NOTIFY, { params }).then(res => {
                let { data = {}, pagination = {} } = res 
                let { countList = [], dataList = [], total = 0 } = data 
                this.menus = countList.map(item => {
                    item.nodeList && item.nodeList.forEach(v => { v.messageNode = String(v.messageNode) })
                    item.icon = menuIcon[item.messageType]
                    item.messageType = String(item.messageType)
                    return item
                })
                this.total = total
                this.pagination = pagination
                this.$emit('getTotal', total)
                this.$emit('getCountList', countList)
                if (!this.menuModel[0] && countList.length > 0) {
                    this.menuModel = [countList[0].messageType]
                    this.menuModel[0] && (this.tabModel[0] = countList[0].nodeList[0].messageNode)
                }
                this.noticeList = dataList.map(item => {
                    item.messageType = this.menuModel[0]
                    item.messageNode = this.tabModel[0]
                    return item
                })
            }).finally(() => this.loading = false)
        },
        selectMenuHandle({ selectedKeys }) {
            let menuModel = selectedKeys[0]
            let target = this.menus.find(item => item.messageType === menuModel)
            if (target.nodeList.length) {
                this.tabModel = [target.nodeList[0].messageNode]
                this.pagination.page = 1
                this.refreshNotify()
            }
        },
        selectTabHandle () {
            this.pagination.page = 1
            this.refreshNotify()
        },
        refreshNotify() {
            this.$nextTick(() => {
                this.getNotifiy({
                    messageType: this.menuModel[0],
                    messageNode: this.tabModel[0]
                })
            })
        },
        winNotify (data) {
            notify().then(() => {
                if (this.notification) {
                    this.notification.close()
                }
                this.notification = new Notification(data.messageTitle, {
                    body: `${data.messageContent} ${formatDate(data.createTime, 'yyyy-MM-dd hh:mm:ss')}`,
                })
                this.notification.onclick = (event) => {
                    event.preventDefault()
                    window.focus()
                    getRoute(data, this.currentUser).then(routerPath => {
                        window.open(`/sass${routerPath}`, '_self')
                    }).finally(() => {
                        this.$axios.post(this.$apis.UPDATE_MESSSAGE_INFO, { messageId: data.messageId })
                            .then(() => this.refreshNotify())
                    })
                    this.notification.close()
                };
                notifyWebTitle(data.messageTitle)
            })
        },
        _linkSocket () {
            const self = this
            // console.log(this.currentUser)
            let url = `${socketUrl}?token=${this.currentUser.userAgentId}`
            let sock = new ReconnectingWebSocket(url);
            sock.onopen = function() {
                sock.send('test')
                setInterval(() => {
                    sock.send('test')
                }, 40000)
            };
            sock.onmessage = function(e) {
                let data = JSON.parse(e.data)
                self.winNotify(data)
                self.refreshNotify()
            };
            this.sock = sock
            this.$eventBus.$on('offNoticeSocket', () => {
                this.sock && this.sock.close()
            })
        },
        toMore () {
            this.$router.push({ name: '消息中心' })
            this.$eventBus.$emit('noticeLayerShow', false)
        },
        isReadChangeHandle () {
            this.$nextTick(() => {
                this.menuModel[0] = ''
                this.getNotifiy()
            })
        },
        pageChangeHandle (page) {
            this.pagination.page = page 
            this.refreshNotify()
        },
        readSuccess () {
            // this.refreshNotify()
            // if (this.pageType === 'page') {
            //     this.$eventBus.$emit('refreshNotice')
            // }
            this.$eventBus.$emit('refreshNotice')
        },
        setAllReadHandle () {
            let body = {
                messageType: this.menuModel[0],
                messageNode: this.tabModel[0]
            }
            this.loading = true
            this.$axios.post(this.$apis.UPDATE_BATCH_MESSAGE_INFO, body).then(res => {
                let { success, data } = res
                if (success) {
                    this.$message.success(data)
                    this.readSuccess()
                    return
                }
                this.$message.error(data)
            }).finally(() => this.loading = false)
        }
    },
    mounted () {
        if (this.pageType === 'layer') {
            this._linkSocket()
            notify()
            // 动态设置浮框定位距离
            this.$nextTick(() => {
                let parentNode = this.$el.parentNode
                let rect = parentNode.getBoundingClientRect()
                this.$el.style.top = rect.height + 'px'
            })
        }   
        this.getNotifiy()
        this.$eventBus.$on('refreshNotice', () => this.refreshNotify())
    },
    destory () {
        this.$eventBus.$off('offNoticeSocket')
        this.$eventBus.$off('refreshNotice')
    }
}
</script>

<style lang="less">
.notice-center {
    background: #fff;
    height: 100%;
    &.layer {
        position: fixed;
        // top: 62px;
        right: 0;
        z-index: 100;
        width: 550px;
        height: 400px;
        border: 1px solid #f2f2f2;
        box-shadow: 2px 2px 4px rgba(0,0,0,.3);
    }
    &.page {
        .notice-tabs {
            .item {
                flex: 0 0 100px;
            }
        }
        .notice-list {
            padding: 10px 0;
        }
    }
    .ant-row {
        height: 100%;
        > div {
            height: 100%;
        }
    }
    .ant-side-menu {
        height: 100%;
        .ant-menu-item .anticon {
            margin-right: 2px;
        }
    }
    .notice-badge {
        .ant-badge-count {
            right: -5px;
            height: 15px;
            min-width: 15px;
            line-height: 15px;
        }
    }
    .notice-tabs {
        display: flex;
        padding: 0 20px;
        border-bottom: 1px solid #f2f2f2;
        line-height: 50px;
        .item {
            flex: 0 0 25%;
            text-align: center;
            position: relative;
            &.active {
                &::after {
                    position: absolute;
                    display: block;
                    content: '';
                    width: 100%;
                    border-bottom: 2px solid #1890ff;
                    bottom: 0;
                    left: 0;
                }
            }
        }
    }
    .notice-tabs-container {
        position: relative;
        display: flex;
        flex-direction: column;
        .notice-flex {
            flex: 1;
        }
        .toolbox {
            position: relative;
            color: #999;
            text-align: center;
            font-size: 12px;
            line-height: 40px;
            > span {
                cursor: pointer;
                &:hover {
                    color: #1890ff;
                }
            }
            .setRead {
                position: absolute;
                right: 20px;
                top: 0;
                color: #1890ff;
            }
        }
        .switch {
            position: absolute;
            right: 20px;
            top: 10px;
        }
        .page-setRead {
            position: absolute;
            right: 20px;
            top: 62px;
            color: #1890ff;
            cursor: pointer
        }
    }
    .no-content {
        min-height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/notice/notice-center.vue